module.exports = require('./helpers/bundle-url').getBundleURL('7XW1A') + "logo-dark.a922e36b.svg";